import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import styles from './BudgetSelectBanner.module.scss';
import { Props } from './BudgetSelectBanner.types';

const BudgetSelectBanner = ({ count, totalAmount, onMarkClick }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.itemCount}>
        {t('expenses.selectBanner.summary', {
          defaultValue_one: '{{count}} dépense sélectionnée · {{total}}€',
          defaultValue_other: '{{count}} dépenses sélectionnées · {{total}}€',
          count,
          total: totalAmount.toFixed(2),
        })}
      </div>
      <Button onClick={onMarkClick}>
        {t('expenses.selectBanner.markReimbursed', {
          defaultValue_one: 'Marquer comme remboursé ({{count}} dépense)',
          defaultValue_other: 'Marquer comme remboursé ({{count}} dépenses)',
          count,
        })}
      </Button>
    </div>
  );
};

export default BudgetSelectBanner;
